import { render } from "./CallForSpecialSessionsView.vue?vue&type=template&id=0be12378"
import script from "./CallForSpecialSessionsView.vue?vue&type=script&lang=js"
export * from "./CallForSpecialSessionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__